import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import {
  addLeaveAllocation,
  getLeaveAllocationDetails,
  updateLeaveAllocation,
} from '../../../network/leaveAllocation';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import { getEmployee, getEmployeeDetails } from '../../../network/employee';
import { getSearchPatients } from '../../../network/appointment';
import { submitMaterialRequest } from '../../../network/materialRequest';
import HeadingApp from '../../../hooks/HeadingApp';
import { PiBatteryVerticalLow } from 'react-icons/pi';
const AddLeaveAllocation = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const [searchTextItems, setSearchTextItems] = useState('');
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddStockEntry } = useMutation({
    mutationKey: ['addStockEntry'],
    mutationFn: (body) =>
      edit ? updateLeaveAllocation(body, id) : addLeaveAllocation(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getLeaveAllocation] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/leave-allocation');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Leave Allocation', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getLeaveAllocation] });
      navigate('/leave-allocation');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data: employeeList } = useQuery({
    queryKey: [queryKeys.getSearchPatientsEmployee, searchTextItems],
    queryFn: () => getSearchPatients('Employee', searchTextItems),
    keepPreviousData: true,
    enabled: searchTextItems?.length >= 3 || searchTextItems?.length === 0,
  });
  const { data: leaveAllocationDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getLeaveAllocation, id],
    queryFn: () => getLeaveAllocationDetails(id),
    enabled: !!edit,
  });
  const { mutate: onGetEmployee } = useMutation({
    mutationKey: [queryKeys.getEmployeeDetails],
    mutationFn: (value) => getEmployeeDetails(value),
    onSuccess: (data) => {
      console.log(data, 'data');
      form.setFieldsValue({
        employee_name: data?.data?.employee_name,
        department: data?.data?.department,
      });
    },
  });
  const { data: leaveType } = useQuery({
    queryKey: [queryKeys.getSearchApiLeaveType],
    queryFn: () => getSearchApi('Leave Type'),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddStockEntry({
      ...values,
      company: companyName,
      from_date: dayjs(values?.from_date).format('YYYY-MM-DD'),
      to_date: dayjs(values?.to_date).format('YYYY-MM-DD'),
      carry_forward: values?.carry_forward ? 1 : 0,
    });
  };
  useEffect(() => {
    if (edit && leaveAllocationDetails) {
      setDataStatus(leaveAllocationDetails?.data?.docstatus);
      form.setFieldsValue({
        ...leaveAllocationDetails?.data,
        from_date: dayjs(leaveAllocationDetails?.data?.from_date),
        to_date: dayjs(leaveAllocationDetails?.data?.to_date),
      });
    } else {
      form.resetFields();
    }
  }, [edit, leaveAllocationDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      <HeadingApp
        nameTab={t.SalesFinance}
        title={t.Customer}
        subTitle={edit ? t.EditLeaveAllocation : t.AddLeaveAllocation}
        icon={<PiBatteryVerticalLow />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-leave-allocation"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="employee"
                label={t.Employee}
                rules={[{ required: true }]}
              >
                <Select
                  placeholder={t.Employee}
                  showSearch
                  optionFilterProp="children"
                  filterOption={false}
                  // filterOption={(input, option) =>
                  //   (option?.label ?? '').toLocaleLowerCase().includes(input)
                  // }
                  onSearch={(value) => setSearchTextItems(value)}
                  onChange={(value, option) => {
                    console.log(option, 'option');
                    onGetEmployee(value);
                    // form.setFieldsValue({
                    //   employee_name: option?.option?.description,
                    //   department: option?.option?.department,
                    // });
                  }}
                  // filterSort={(optionA, optionB) =>
                  //   (optionA?.label ?? '')
                  //     .toLowerCase()
                  //     .localeCompare((optionB?.label ?? '').toLowerCase())
                  // }
                  options={employeeList?.message?.map((user) => ({
                    value: user.value,
                    label: user.value,
                    option: user,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="employee_name"
                label={t.employeeName}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.employeeName} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item name="department" label={t.department}>
                <Input placeholder={t.department} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="leave_type"
                label={t.LeaveType}
                rules={[{ required: true }]}
              >
                <Select
                  placeholder={t.LeaveType}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  options={leaveType?.message?.map((user) => ({
                    value: user.value,
                    label: user.value,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="from_date"
                label={t.fromDate}
                rules={[{ required: true }]}
                initialValue={dayjs()}
              >
                <DatePicker
                  placeholder={t.fromDate}
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="to_date"
                label={t.ToDate}
                rules={[{ required: true }]}
                initialValue={dayjs().add(1, 'year')}
              >
                <DatePicker
                  placeholder={t.ToDate}
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="new_leaves_allocated"
                label={t.newLeavesAllocated}
              >
                <Input type="number" placeholder={t.newLeavesAllocated} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
              <Form.Item name="unused_leaves" label={t.unusedLeaves}>
                <Input type="number" placeholder={t.unusedLeaves} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
              <Form.Item
                name="total_leaves_allocated"
                label={t.totalLeavesAllocated}
              >
                <Input
                  type="number"
                  placeholder={t.totalLeavesAllocated}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
              <Form.Item
                name="total_leaves_encashed"
                label={t.totalLeavesEncashed}
              >
                <Input
                  type="number"
                  placeholder={t.totalLeavesEncashed}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
              <Form.Item
                name="carry_forwarded_leaves_count"
                label={t.carryForwardedLeavesCount}
              >
                <Input
                  type="number"
                  placeholder={t.carryForwardedLeavesCount}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
              <Form.Item name="expired" label={t.expired}>
                <Input type="number" placeholder={t.expired} disabled />
              </Form.Item>
            </Col>
            <Col xs={12} md={12} xl={8} xxl={8}>
              <Form.Item name="carry_forward" valuePropName="checked">
                <Checkbox>{t.carryForward}</Checkbox>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="description" label={t.description}>
                <Input.TextArea rows={4} placeholder={t.description} />
              </Form.Item>
            </Col>
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              {t.cancel}
            </Button>
            <Button
              type="primary"
              loading={loadingAdd}
              onClick={() => {
                if (submitButton) {
                  setLoadingAdd(true);
                  handleSubmit.mutate(selectName);
                } else {
                  form.submit();
                }
              }}
            >
              {/* {edit ? t.edit : t.submit} */}
              {submitButton ? t.submit : edit ? t.edit : t.Save}
            </Button>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default AddLeaveAllocation;
